<div class="sign-in-text">Waiting For OTP</div>
<p class="sign-in-subtext">
  OTP sent to mobile number <span>{{ mobile_number }}</span>
</p>

<form (submit)="signIn()">
  <div class="otp-container">
    <input
    #otpInput
      type="tel"
      maxlength="6"
      class="otp-input"
      [(ngModel)]="otp"
      (keydown)="allowOnlyNumbers($event)"
      (beforeinput)="onBeforeInput($event)" 
      (input)="formatOtp()"
      (click)="setCursorToEnd()"
      (paste)="onPaste($event)"
    />
    <div class="otp-mask">
      @for (num of otpArray; let i = $index; track num) {
        <div>{{ num }}</div>
      }
    </div>
  </div>
  <input type="submit" style="position: absolute; left: -9999px" />
</form>

<div class="content-wrapper">
  <button btn-primary size="full" (click)="signIn()" [isLoading]="btnLoading">Submit</button>
</div>

@if (!enable_resend_otp) {
  <div class="content-wrapper">
    <span>Resend OTP in </span>
    <span style="color: var(--primary-color)"> 00:{{ time_left }} </span>
  </div>
}

@if (enable_resend_otp) {
  <div class="content-wrapper">
    <span class="resend-otp">Resend OTP via</span> <br />
    <div class="resend-otp-wrapper">
      <button (click)="generateOtp('otp')" class="resend-cta center">
        <img style="margin-right: 5px" src="{{ DEPLOY_URL }}/assets/images/sms_teal.svg" />
        SMS
      </button>
      <button (click)="generateOtp('whatsapp_otp')" class="resend-cta center">
        <img style="margin-right: 5px" src="{{ DEPLOY_URL }}/assets/images/whatsapp_teal.svg" />
        WhatsApp
      </button>
    </div>
  </div>
}

@if (loginWithPassword) {
  <p data-test="login-with-password" class="login-with" (click)="loginWPassword()">Login with Password</p>
}
<p class="login-with" (click)="changeMobileNumber()">Change Number</p>
